import { ChevronRightIcon, ChevronUpIcon } from '@primer/octicons-react';
import { Box, IconButton } from '@primer/react';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import DataTable from '../../components/ui/data-table';
import { IColumn } from '../../components/ui/data-table/DataTable';
import { useThongKeSiSo } from '../../hooks/useThongKeSiSo';
import { actions } from '../../state/actions/actionsWrapper';
const mainAction = actions.thongKe.thongKeSiSo;
const ThongKeSiSoDataTable = () => {
    const { dataStructed, expandedIds, dmTrangThais } = useThongKeSiSo();
    const dispatch = useDispatch();
    const dataSource = useMemo(() => {
        let result: any[] = [];
        dataStructed.forEach((_truong, _truongId) => {
            const truongId = _truongId;
            let itemTruong: any = {
                ..._truong,
                id: truongId,
                items: [],
                trangThaiSum: undefined
            }
            _truong.trangThaiSum.forEach((value, key) => {
                itemTruong[`T_${key}`] = value;
            })
            result.push(itemTruong)
            if (expandedIds.has(truongId)) {
                _truong.items.forEach((_khoi, _khoiId) => {
                    const khoiId = `${truongId}_${_khoiId}`;
                    let itemKhoi: any = {
                        ..._khoi,
                        id: khoiId,
                        items: [],
                        trangThaiSum: undefined
                    }
                    _khoi.trangThaiSum.forEach((value, key) => {
                        itemKhoi[`T_${key}`] = value;
                    })
                    result.push(itemKhoi)
                    if (expandedIds.has(khoiId)) {
                        _khoi.items.forEach((_he, _heId) => {
                            const heId = `${khoiId}_${_heId}`;
                            let itemHe: any = {
                                ..._he,
                                id: heId,
                                items: [],
                                trangThaiSum: undefined
                            }
                            _he.trangThaiSum.forEach((value, key) => {
                                itemHe[`T_${key}`] = value;
                            })
                            result.push(itemHe)
                            if (expandedIds.has(heId)) {
                                _he.items.forEach((_lop, _lopId) => {
                                    let itemLop: any = {
                                        ..._lop,
                                        id: _lopId,
                                        items: [],
                                        trangThaiSum: undefined
                                    }
                                    _lop.trangThaiSum.forEach((value, key) => {
                                        itemLop[`T_${key}`] = value;
                                    })
                                    result.push(itemLop)
                                })
                            }
                        })
                    }
                })

            }
        })
        return result;
    }, [dataStructed, expandedIds])


    const columns: IColumn[] = useMemo(() => {
        let result: IColumn[] = [
            {
                dataField: "name",
                caption: "Trường/ Khối/ Hệ/ Lớp",
                isMainColumn: true,
                cellRender: (data: any) => {
                    const isExpanded = expandedIds.has(data.id);
                    const type = data.type;
                    let level = 0;
                    if (type === "khoi") level = 1;
                    if (type === "he") level = 2;
                    if (type === "lop") level = 3;
                    return (
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Box sx={{ width: `${(level) * 30}px` }}>
                                &nbsp;
                            </Box>
                            {type !== "lop" &&
                                <IconButton icon={!isExpanded ? ChevronRightIcon : ChevronUpIcon}
                                    aria-label=''
                                    variant='invisible'
                                    size='small'
                                    onClick={() => {
                                        let newMap = new Map(expandedIds);
                                        if (isExpanded) {
                                            newMap.delete(data.id)
                                        } else {
                                            newMap.set(data.id, data.id)
                                        }
                                        dispatch(mainAction.CHANGE_EXPANDED_IDS(newMap))
                                    }}
                                />
                            }
                            <Box>
                                {data.name}
                            </Box>
                        </Box>
                    );
                }
            },
            {
                dataField: "si_so",
                caption: "Sĩ số",
                align: "right"
            }
        ]
        dmTrangThais.forEach((value) => {
            result.push({
                dataField: `T_${value.id}`,
                caption: value.name,
                align: "right",
                width: "120px"
            })
        })
        return result;
    }, [dmTrangThais, expandedIds])
    return (
        <>
            <DataTable
                data={dataSource}
                columns={columns}
            />
        </>
    );
};

export default ThongKeSiSoDataTable;